import { useState } from "react";
import "@/App.css";
import { Toaster } from "@/components/ui/sonner";
import { toast } from "sonner";
import { useCart } from "@/hooks/useCart";
import Navbar from "@/components/Navbar";
import Hero from "@/components/Hero";
import Interests from "@/components/Interests";
import About from "@/components/About";
import Products from "@/components/Products";
import ProductModal from "@/components/ProductModal";
import CartDrawer from "@/components/CartDrawer";
import Suppliers from "@/components/Suppliers";
import Contact from "@/components/Contact";
import Footer from "@/components/Footer";
import FloatingWhatsApp from "@/components/FloatingWhatsApp";

export default function App() {
  const cart = useCart();
  const [filter, setFilter] = useState("All");
  const [cartOpen, setCartOpen] = useState(false);
  const [detail, setDetail] = useState(null);

  const selectCategory = (category) => {
    setFilter(category);
    document.getElementById("products")?.scrollIntoView({ behavior: "smooth" });
  };

  const addToCart = (id) => {
    cart.add(id);
    toast.success("Added to cart");
  };

  return (
    <div className="App min-h-screen bg-[#f7f5f1]">
      <Navbar cartCount={cart.count} onCartOpen={() => setCartOpen(true)} />
      <main>
        <Hero />
        <Interests onSelect={selectCategory} />
        <About />
        <Products filter={filter} onFilter={setFilter} onAdd={addToCart} onView={setDetail} />
        <Suppliers />
        <Contact />
      </main>
      <Footer />
      <FloatingWhatsApp />
      <ProductModal product={detail} onClose={() => setDetail(null)} onAdd={addToCart} />
      <CartDrawer open={cartOpen} onClose={() => setCartOpen(false)} cart={cart} />
      <Toaster position="bottom-left" />
    </div>
  );
}
